var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import { styled, LinearProgress, Box, Tooltip, } from '@mui/material';
import filesize from 'filesize';
import { RefreshIcon, DeleteIcon } from '../../icons';
import Typography from '../../Typography';
import { FileIcons, getFileFormat } from '../utils';
import IconButton from '../../IconButton';
function formatInfo(size, percent) {
    return filesize(size * (percent / 100)) + " / " + filesize(size);
}
var FlexCenterBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
});
var ListItemRoot = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    minHeight: 56,
    padding: '0 16px',
    '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
        borderRadius: '4px',
        cursor: 'pointer',
    },
});
var FlexFill = styled(Box)({
    flex: 1,
    minWidth: 0,
});
var ActionIconBox = styled('span')({
    cursor: 'pointer',
    position: 'relative',
    marginLeft: 8,
});
var FileName = styled(Typography)({
    color: 'rgba(0, 0, 0, 0.86)',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '22px',
    minWidth: 0,
});
var Progress = styled(LinearProgress)({
    width: '100%',
    mr: '25px',
    borderRadius: 4,
});
var IconImage = styled(Box)(function (_a) {
    var src = _a.src;
    return ({
        backgroundImage: "url(" + src + ")",
        borderRadius: 4,
        height: 56,
        width: 56,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        margin: '16px 8px 16px 0'
    });
});
var progressColors = {
    uploading: 'primary',
    error: 'error',
    done: 'primary',
};
var ListItem = function (_a) {
    var 
    // 文件名称
    name = _a.name, originFileObj = _a.originFileObj, size = _a.size, 
    // 上传进度
    percentProp = _a.percent, 
    // 上传状态
    status = _a.status, url = _a.url, iconType = _a.iconType, onClose = _a.onClose, onRefresh = _a.onRefresh, nameRender = _a.nameRender, restProps = __rest(_a, ["name", "originFileObj", "size", "percent", "status", "url", "iconType", "onClose", "onRefresh", "nameRender"]);
    var blobSrc = useMemo(function () {
        // @ts-ignore
        if (originFileObj === null || originFileObj === void 0 ? void 0 : originFileObj.originFileObj) {
            // @ts-ignore
            return URL.createObjectURL(originFileObj.originFileObj);
        }
        if (originFileObj) {
            return URL.createObjectURL(originFileObj);
        }
        return null;
    }, [originFileObj]);
    var fileIcon = useMemo(function () {
        if (iconType === 'image' && blobSrc) {
            return React.createElement(IconImage, { src: blobSrc });
        }
        var fileFormat = getFileFormat(name);
        var FileIcon = FileIcons[fileFormat] || FileIcons['undefined'];
        return React.createElement(FileIcon, { sx: { mr: 1 } });
    }, [name, iconType, blobSrc]);
    var progress = status === 'error' ? 100 : percentProp;
    var StatusIcons = {
        // uploading: (
        //   <Tooltip title={'取消上传'} placement="top">
        //     <IconButton >
        //       <CloseIcon onClick={() => onClose()} />
        //     </IconButton>
        //   </Tooltip>
        // ),
        error: (React.createElement(Tooltip, { title: '重新上传', placement: "top" },
            React.createElement(IconButton, null,
                React.createElement(RefreshIcon, { onClick: function () { return onRefresh(); } })))),
        done: (React.createElement(Tooltip, { title: '删除文件', placement: "top" },
            React.createElement(IconButton, null,
                React.createElement(DeleteIcon, { onClick: function () { return onClose(); } })))),
    };
    var handleViewFile = useCallback(function () {
        if (blobSrc) {
            window.open(blobSrc);
        }
        else if (url) {
            window.open(url);
        }
    }, [blobSrc, url]);
    return (React.createElement(ListItemRoot, null,
        React.createElement(FlexCenterBox, { onClick: handleViewFile, sx: { flex: 1, cursor: 'pointer' } },
            fileIcon,
            React.createElement(FlexFill, null,
                React.createElement(FileName, null, nameRender()),
                status === 'uploading' && (React.createElement(FlexCenterBox, { sx: { flex: 1, position: 'relative' } },
                    React.createElement(Progress, { variant: "determinate", value: progress, color: progressColors[status] }))),
                status === 'error' ? (React.createElement(Typography, { variant: "caption", color: "error" }, "\u4E0A\u4F20\u5931\u8D25")) : (React.createElement(Typography, { variant: "caption", color: "secondary" }, formatInfo(size, percentProp))))),
        React.createElement(ActionIconBox, null, StatusIcons[status] || null)));
};
export default ListItem;
